export default __webpack_public_path__ + "static/media/arrowIcon.afaf334f.svg";